<template>
	<footer class="footerWrap">
		<div class="contact">
			<div class="siteInfo">
				<img class="logo" :src="system.bottom_logo" alt="">
				<p class="name">{{ system.name }}旗下官方购票平台</p>
			</div>
			<div class="contactsWrap">
				<div class="item">
					<img class="qrcode" :src="system.weixin_qrcode" alt="" />
					<p class="qrcodeDesc">微信公众号<br>舜山小镇</p>
				</div>
				<div class="item">
					<img class="qrcode" :src="system.xiaohongshu_qrcode" alt="" />
					<p class="qrcodeDesc">小红书<br>舜山小镇</p>
				</div>
				<div class="item">
					<img class="qrcode" :src="system.douyin_qrcode" alt="" />
					<p class="qrcodeDesc">抖音<br>@舜山小镇</p>
				</div>
				<div class="item">
					<img class="qrcode" :src="system.shipinhao_qrcode" alt="" />
					<p class="qrcodeDesc">视频号<br>@舜山小镇</p>
				</div>
			</div>
		</div>
		<div class="links">
			<div class="tel">
				<p>游客服务热线</p>
				<p>{{ system.telephone }}</p>
			</div>
			<div class="contactsWrap">
				<div class="item">
					<p><a href="javascript:;">关于我们</a></p>
					<p v-for="(item, index) in aboutList" :key="index"><a :href="item.link_url">{{ item.title }}</a>
					</p>
				</div>
				<div class="item">
					<p><a href="javascript:;">帮助中心</a></p>
					<p v-for="(item, index) in touristList" :key="index"><a :href="item.link_url">{{ item.title }}</a>
					</p>
				</div>
				<div class="item">
					<p><a href="javascript:;">服务说明</a></p>
					<p v-for="(item, index) in serviceList" :key="index"><a :href="item.link_url">{{ item.title }}</a>
					</p>
				</div>
				<div class="item">
					<p><a href="javascript:;">网站条款</a></p>
					<p v-for="(item, index) in termList" :key="index"><a :href="item.link_url">{{ item.title }}</a></p>
				</div>
			</div>
		</div>
		<div class="copyright">
			<p>{{ system.copyright }} 版权所有 备案号：<a href="https://beian.miit.gov.cn/">{{ system.beian }}</a> 经营性备案：<a
					href="#">{{ system.manage_beian }}</a></p>
			<p>技术支持：<a href="https://www.leaeer.com" target="_blank">江苏领艺科技</a></p>
		</div>
	</footer>
</template>

<script>
import { getSystemConfig, getFooterLink } from '@/api/common'
export default {
	name: 'Footer',
	components: {

	},
	computed: {

	},
	data() {
		return {
			system: {},
			aboutList: [],
			touristList: [],
			serviceList: [],
			termList: []
		}
	},
	created() {
		this.getSystemConfig()
		this.getFooterLink()
	},
	methods: {
		getSystemConfig() {
			getSystemConfig({}).then(res => {
				this.system = res.data
			})
		},
		getFooterLink() {
			getFooterLink({}).then(res => {
				this.aboutList = res.data.aboutList
				this.touristList = res.data.touristList
				this.serviceList = res.data.serviceList
				this.termList = res.data.termList
			})
		}
	}

}
</script>

<style lang="scss" scoped></style>
